import { Component, OnInit } from '@angular/core';
import type { CryptoFees, FiatFees } from 'src/app/models/exchange-fees';
import { FeesService } from 'src/app/api/fees.service';
import { AuthService } from 'src/app/api/auth.service';
import { FeeTabs } from 'src/app/models/fees';
import { tap } from 'rxjs/operators';
import { MetadataService } from 'src/app/api/metadata.service';
import { environment } from 'src/environments/environment';
import { Country } from 'src/app/models/country';
import { MobileWebViewService } from 'src/app/services/mobile-web-view.service';

@Component({
  selector: 'app-fees',
  templateUrl: './fees-page.component.html',
  styleUrls: ['./fees-page.component.scss']
})
export class FeesPageComponent implements OnInit {
  loading = false;
  error: string = null;

  FeeTabs = FeeTabs;
  selectedTab: FeeTabs;
  cryptoFees: CryptoFees;
  fiatFees: FiatFees;
  fiatCurrency: string;
  country : Country;

  isMobileWebView$ = this.mobileWebViewService.isMobileWebView$;

  constructor(
    private auth: AuthService,
    private feesService: FeesService,
    private metadataService: MetadataService,
    private mobileWebViewService: MobileWebViewService,
  ) { }

  async ngOnInit() {
    this.setDefaultCountry();
    this.getUserCountry();
    await this.getExchangeFees();

    // TODO: request fees
    // this.getFiatFees();
  }

  setDefaultCountry (){
    this.metadataService.getCountry(248).subscribe(response => {
      this.country = response;
      this.setFiatCurrency('AED');
    });
  }

  getUserCountry (){
    this.metadataService.userCountry().subscribe(response => {
      if(response){
        this.metadataService.getCountry(response.id).subscribe(response => {
          if (environment.countries.hasOwnProperty(response.code3)){
            this.country = response;
            this.setFiatCurrency(environment.countries[this.country.code3].currency);
          }
        });
      }
    });
  }

  setFiatCurrency(currency: string) {
    this.fiatCurrency = currency;
  }

  getExchangeFees() {
    this.loading = true;
    this.error = null;

    return this.feesService.getCryptoFees().pipe(
      tap(response => {
        this.loading = false;
        this.cryptoFees = response;
      }, (err) => {
        this.loading = false;
        this.error = err.errors[0].message;
      })
    ).toPromise();
  }

  getFiatFees() {
    this.loading = true;
    this.error = null;

    this.feesService.getFiatFees().subscribe(response => {
      this.loading = false;
      this.fiatFees = response;
    }, err => {
      this.loading = false;
      this.error = err.errors[0].message;
    });
  }

  handleTabChange(tab: FeeTabs) {
    this.selectedTab = tab;
  }

  isLoggedIn() {
    return this.auth.getToken();
  }
}
